import { render, staticRenderFns } from "./clinicIsDefault.vue?vue&type=template&id=deddb026&scoped=true"
import script from "./clinicIsDefault.vue?vue&type=script&lang=js"
export * from "./clinicIsDefault.vue?vue&type=script&lang=js"
import style0 from "./clinicIsDefault.vue?vue&type=style&index=0&id=deddb026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deddb026",
  null
  
)

export default component.exports